module.exports = __webpack_public_path__ + "img/sy-remark.04f41de9.svg";